define("calendar/modifiers/set-background-color", ["exports", "ember-modifier", "shared/utils/hex-to-rgb"], function (_exports, _emberModifier, _hexToRgb) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.setBackgroundColor = setBackgroundColor;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier",0,"shared/utils/hex-to-rgb"eaimeta@70e063a35619d71f
  /**
   * Gets a string or undefined representing a HEX color code and converts it to an RGBA.
   *
   * @param element HTMLElement to apply background color to
   * @param param1 Hex color code string
   */
  function setBackgroundColor(element, _ref) {
    let [color] = _ref;
    if (!color) return;

    // Set the background color
    const rgb = (0, _hexToRgb.default)(color, 0.3);
    if (rgb) {
      element.style.backgroundColor = rgb;
      element.style.border = 'none';
    }
  }
  const setBackgroundColorModifier = (0, _emberModifier.modifier)(setBackgroundColor, {
    eager: false
  });
  var _default = _exports.default = setBackgroundColorModifier;
});